<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 2/9/2020
  -->

<template>
	<div class="form-element-type-select-root">
		<el-select v-model="valueData"
				   value-key="value"
				   name="label" placeholder="Select" v-tabindex="-1"
				   popper-class="form-element-type-select-popup-root"
				   @change="notifyValueChanged">
			<el-option-group
				v-for="group in options"
				:key="group.label"
				:label="group.label">
				<ToolTipView
					class="el-select-group__title"
					:text="group.tooltip"
					style="position: absolute; top: -2px; right: 9px;"/>
				<el-option
					v-for="item in group.types"
					class="ml-3"
					:key="item.value"
					:label="item.label"
					:disabled="isDisabledFn(item)"
					:value="item">
				</el-option>
			</el-option-group>
		</el-select>

	</div>
</template>

<script>
import BaseVModelView from "@/core/components/BaseVModelView.vue";
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";

export default {
	name: "FormElementTypeSelect",
	components: {ToolTipView},
	extends: BaseVModelView,

	props: {
		isDisabledFn: {Function, default: () => (item) => false},
	},

	data() {
		return {
			options: [
				{
					label: "General Questions",
					tooltip: "General questions for your clients.<br/><br/>Use them to ask your custom questions.<br/><br/>Answers to these questions will be added to your client's general responses.",
					types: [
						{value: FormElementType.MULTILINE, label: "Text Answer"},
						{value: FormElementType.RADIOBUTTONS, label: "Multiple choice"},
						{value: FormElementType.CHECKBOXES, label: "Checkboxes"},
						{value: FormElementType.CONTACT_INFO, label: "Contact Info"},
						// {value: FormElementType.TEXT_GRID, label: "Text Grid"},
						{value: FormElementType.DATE, label: "Date"},
					]
				},
				{
					label: "Smart Questions",
					tooltip: "Answers to these questions will be added to the client's profile.<br/><br/>These questions will be automatically hidden from those clients who already answered them.",
					types: [
						{value: FormElementType.FULL_NAME, label: "Full Name"},
						{value: FormElementType.EMAIL_ADDRESS, label: "Email Address"},
						{value: FormElementType.ADDRESS, label: "Address"},
						{value: FormElementType.DATE_OF_BIRTH, label: "Date of Birth"},
						{value: FormElementType.PHONE_NUMBER, label: "Phone Number"},
						{value: FormElementType.EMERGENCY_CONTACTS, label: "Emergency Contacts"},
					]
				},
				{
					label: "Additional Elements",
					tooltip: "Additional elements provide a way to add additional information to your form.<br/><br/>For example you can use it to add your contact details, general description of the form etc.",
					types: [
						{value: FormElementType.TITLE, label: "Title"},
						{value: FormElementType.FOOTER, label: "Footer"},
						{value: FormElementType.SCORE_RESULT, label: "Score Result"},
						// {value: FormElementType.SCORE_RESULT, label: "Range Score Result"},
						// {value: FormElementType.SCORE_BUCKET_RESULT, label: "Bucket Score Result"},
					]
				}],
		}
	},


	methods: {

		formatDataIn(data) {
			console.log("formatDataIn: data = ", data, ", this.types = ", this.types)
			for (let option of this.options) {
				for (let type of option.types) {
					console.log("formatDataIn: type = ", type)
					if (type.value === data) {
						return type
					}
				}
			}
			return this.options[0].types[0]
		},

		formatDataOut(data) {
			return data.value
		},
	}

}
</script>

<style lang="scss">

.form-element-type-select-root{
	.el-input__inner{
		height: px-to-rem(40) !important;
	}
}

.form-element-type-select-popup-root{
	.el-select-dropdown__wrap{
		max-height: 100vh;
	}

}

</style>
